import { render, staticRenderFns } from "./InsuranceBoxes.vue?vue&type=template&id=37ae410d&scoped=true&"
import script from "./InsuranceBoxes.vue?vue&type=script&lang=js&"
export * from "./InsuranceBoxes.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBoxes.vue?vue&type=style&index=0&id=37ae410d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae410d",
  null
  
)

export default component.exports